import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import { NearbyTobaccoFinder } from "@/components/NearbyTobaccoFinder";

export default function RetailerFinderPage() {
  return (
    <main className="min-h-screen bg-white">
      <section className="mx-auto max-w-6xl px-4 pb-8 pt-10 md:pb-12 md:pt-16">
        <Link href="/" className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900">
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>
        <div className="max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">Offline retail support</p>
          <h1 className="text-4xl font-bold tracking-tight text-slate-950 md:text-6xl">Find offline IGET retailers</h1>
          <p className="mt-5 text-lg leading-8 text-slate-600">
            Search public map information for nearby tobacco and authorised retail locations by Australian city, postcode, or area.
          </p>
        </div>
      </section>
      <NearbyTobaccoFinder />
    </main>
  );
}
